import { get, post, put, del, patch } from '../survey-api';

export const createGetEndpoint = (path) => (data) => get(path, { data });
export const createPostEndpoint = (path) => (data) => post(path, { data });
export const createDelEndpoint = (path) => (data) => del(path, { data });
export const createPutEndpoint = (path) => (data) => put(path, { data });
export const createPatchEndpoint = (path) => (data) => patch(path, { data });
